<div class="modal-overlay" *ngIf="isOpen" (click)="onOverlayClick($event)">
  <div
    class="modal-content"
    role="dialog"
    aria-modal="true"
    aria-labelledby="tunnel-package-form-title"
    (click)="$event.stopPropagation()"
  >
    <div class="modal-header">
      <h2 class="modal-title" id="tunnel-package-form-title">{{ modalTitle }}</h2>
      <button
        type="button"
        class="close-button"
        (click)="onClose()"
        [disabled]="isSubmitting"
        aria-label="Close"
      >
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path
            d="M15 5L5 15M5 5L15 15"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <form class="modal-form" (ngSubmit)="onSubmit()">
      <div class="modal-body">
        <div class="form-field">
          <label class="field-label" for="tunnel-package-name"
            >Name <span class="required">*</span></label
          >
          <input
            id="tunnel-package-name"
            type="text"
            class="form-input"
            [class.error]="errors.name"
            [(ngModel)]="name"
            name="tunnelPackageName"
            placeholder="e.g. Ultimate"
            [attr.maxlength]="nameMaxLength"
            [disabled]="isSubmitting"
            autocomplete="off"
          />
          <p class="helper-text">The wash program as the tunnel controller knows it.</p>
          <div class="error-message" *ngIf="errors.name">{{ errors.name }}</div>
        </div>

        <div class="form-field">
          <label class="field-label" for="tunnel-package-relay"
            >C-relay port <span class="required">*</span></label
          >
          <input
            id="tunnel-package-relay"
            type="text"
            inputmode="numeric"
            class="form-input port-input"
            [class.error]="errors.relay"
            [(ngModel)]="relay"
            name="tunnelPackageRelay"
            placeholder="e.g. 3"
            maxlength="3"
            [disabled]="isSubmitting"
            autocomplete="off"
          />
          <p class="helper-text">
            Port {{ relayMin }}–{{ relayMax }} on the I/O module wired to the tunnel controller
            input for this wash.
          </p>
          <div class="error-message" *ngIf="errors.relay">{{ errors.relay }}</div>
        </div>

        <div class="form-field">
          <label class="field-label" for="tunnel-package-pulse">Pulse (ms)</label>
          <input
            id="tunnel-package-pulse"
            type="text"
            inputmode="numeric"
            class="form-input port-input"
            [class.error]="errors.pulseMs"
            [(ngModel)]="pulseMs"
            name="tunnelPackagePulse"
            [placeholder]="pulseDefault"
            maxlength="5"
            [disabled]="isSubmitting"
            autocomplete="off"
          />
          <p class="helper-text">
            How long the relay stays closed, {{ pulseMin }}–{{ pulseMax }} ms (default
            {{ pulseDefault }}).
          </p>
          <div class="error-message" *ngIf="errors.pulseMs">{{ errors.pulseMs }}</div>
        </div>

        <div class="form-field" *ngIf="isEdit">
          <span class="field-label">Status</span>
          <div class="zone-options">
            <label class="zone-radio">
              <input
                type="radio"
                name="tunnelPackageStatus"
                value="active"
                [(ngModel)]="status"
                [disabled]="isSubmitting"
              />
              Active
            </label>
            <label class="zone-radio">
              <input
                type="radio"
                name="tunnelPackageStatus"
                value="inactive"
                [(ngModel)]="status"
                [disabled]="isSubmitting"
              />
              Inactive
            </label>
          </div>
          <p class="helper-text" *ngIf="status === 'inactive'">
            An inactive tunnel wash package never fires; packages linked to it must be started by
            hand.
          </p>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn-cancel" (click)="onClose()" [disabled]="isSubmitting">
          Cancel
        </button>
        <button type="submit" class="btn-save" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Saving…' : submitLabel }}
        </button>
      </div>
    </form>
  </div>
</div>
